import { render } from "./CentersForm.vue?vue&type=template&id=4a329158"
import script from "./CentersForm.vue?vue&type=script&lang=js"
export * from "./CentersForm.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/moncasan_app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__